module.exports = __webpack_public_path__ + "img/google-tag-manager.75c44707.png";